module.exports = __webpack_public_path__ + "img/flow2.d299b8ed.png";